const configVars = {
  API_ENDPOINT: 'https://agile-dusk-36778.herokuapp.com/api',
  TOKEN_KEY: 'move-med-client-auth-token',
}

export default configVars;